import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MotifDal } from '../dal/motif.dal';
import { Motif } from '../models/motif.model';

@Injectable({
  providedIn: 'root',
})
export class MotifService {
  constructor(private Motifdal: MotifDal) {}

  getAllMotifs(dataType?: string): Observable<Motif[]> {
    return this.Motifdal.getAllMotifs(dataType);
  }
}
